import { render, staticRenderFns } from "./RiskMitigationAction.vue?vue&type=template&id=5c2bf504&scoped=true&"
import script from "./RiskMitigationAction.vue?vue&type=script&lang=js&"
export * from "./RiskMitigationAction.vue?vue&type=script&lang=js&"
import style0 from "./RiskMitigationAction.vue?vue&type=style&index=0&id=5c2bf504&lang=scss&scoped=true&"
import style1 from "./RiskMitigationAction.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2bf504",
  null
  
)

export default component.exports